jQuery(document).ready(function($){
    $(".js-expand-trigger").on("click", function(){
        $(this).toggleClass("faqexpand");
    });
});